import { Avatar } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useMaterialUIController } from 'context';
import { LeadResponse } from '../../services/responses/lead.response';
import { getCrmColors } from '../../crm-theme';
import { OwnerAvatarSize, addOwnerIconSx, ownerAvatarSx } from './crm-lead-owner-avatar.styles';

/// Iniciais do nome, para o avatar.
export const getInitials = (name: string) => name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');

interface Props {
    lead: LeadResponse;
    size: OwnerAvatarSize;
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

/// Avatar do responsável, na cor dele em todo lead; sem dono, um "+" para atribuir.
export const CrmLeadOwnerAvatar = ({ lead, size, onClick }: Props) => {
    const [controller] = useMaterialUIController();
    const cc = getCrmColors(controller.darkMode);
    const owner = lead.assignedUserName ? lead.assignedUserColor || cc.accent : null;

    return (
        <Avatar onClick={onClick} sx={ownerAvatarSx(cc, owner, size, Boolean(onClick))}>
            {owner ? getInitials(lead.assignedUserName) : <AddIcon sx={addOwnerIconSx(size)} />}
        </Avatar>
    );
};
